import { useNavigate } from "react-router-dom";
import Button from "../components/button/button";

export default function NotFoundPage() {
    const navigate = useNavigate();
    return <>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '70vh',
        }}>
            <h1 style={{ fontSize: '8rem', margin: 0 }}>404</h1>
            <p style={{ fontSize: '1.5rem' }}>Oops! Page not found.</p>
            <Button onClick={() => navigate('/')}>Go Home</Button>
        </div>
    </>
}